<!-- src/components/SymptomBarChart.vue -->
<template>
  <div>
    <div id="symptom-chart">
      <apexchart
        type="bar"
        :height="height"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SymptomBarChart',
  props: {
    series: {
      type: Array,
      required: true
    },
    categories: {
      type: Array,
      required: true
    },
    height: {
      type: Number,
      default: 400
    },
    colors: {
      type: Array,
      default: () => ['#0058FF', '#21D59B', '#FFC700', '#F99600', '#EA5455', '#546E7A']
    },
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          type: 'bar',
          height: this.height,
          stacked: true,
          toolbar: {
            show: false
          }
        },
        colors: this.colors,
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: 'top'
            }
          }
        },
        dataLabels: {
          enabled: true,
          offsetX: -6,
          style: {
            fontSize: '12px',
            colors: ['#fff']
          },
          formatter: function(val) {
            return val > 0 ? val : '';
          }
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        xaxis: {
          categories: this.categories,
          labels: {
            formatter: function (val) {
              return val
            }
          }
        },
        yaxis: {
          title: {
            text: undefined
          }
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val
            }
          }
        },
        fill: {
          opacity: 1
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
          offsetY: 10
        }
      }
    }
  }
}
</script>
